import { render } from "./CatalogoUsuario.vue?vue&type=template&id=84dce6fe&ts=true"
import script from "./CatalogoUsuario.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoUsuario.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/governanca/usuario/catalogo/apresentacao/CatalogoUsuario.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84dce6fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84dce6fe', __exports__)) {
    api.reload('84dce6fe', __exports__)
  }
  
  module.hot.accept("./CatalogoUsuario.vue?vue&type=template&id=84dce6fe&ts=true", () => {
    api.rerender('84dce6fe', render)
  })

}


export default __exports__